// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DDOSuggestionsResult
// ====================================================

export interface DDOSuggestionsResult {
  /**
   * The full address of the location.
   */
  fullAddress: string;
  /**
   * The 10-digit Borough-Block-Lot (BBL) of the location.
   */
  bbl: string;
  /**
   * Whether the location's BBL is a NYCHA property.
   */
  isNychaBbl: boolean;
  /**
   * Whether the location is eligible for NYC's Right to Counsel program.
   */
  isRtcEligible: boolean;
  /**
   * The zip code of the location. It may be blank.
   */
  zipcode: string;
  /**
   * The year that any buildings on the BBL were built, if available.
   */
  yearBuilt: number | null;
  /**
   * The 2-character building class of the BBL, as defined by the Dept. of City Planning.
   */
  buildingClass: string | null;
  /**
   * Number of residential units for the BBL, if available.
   */
  unitCount: number;
  /**
   * Number of HPD complaints for the BBL. If there are no listed complaints, this will be null.
   */
  hpdComplaintCount: number | null;
  /**
   * Number of open HPD violations for the BBL.
   */
  hpdOpenViolationCount: number;
  /**
   * The number of hpd violations associated with entered bbl that are class C violations (since 2010).
   */
  hpdOpenClassCViolationCount: number | null;
  /**
   * Number of associated buildings from the portfolio that the BBL is in. If the
   * value is unknown, or if there are no associated buildings, this will be null.
   * Also, if the value is unknown, or if there are no associated buildings, this
   * means that the search BBL does not have any HPD registration on file.
   */
  associatedBuildingCount: number | null;
  /**
   * Number of distinct zip codes of associated buildings from the portfolio that
   * the BBL is in. If the value is unknown, or if there are no associated
   * buildings, this will be null.
   */
  associatedZipCount: number | null;
  /**
   * The number of residential units in the portfolio that the BBL belongs to. If
   * the value is unknown, or if there are no associated buildings, this will be null.
   */
  portfolioUnitCount: number | null;
  /**
   * The number of evictions from all associated buildings in portfolio.
   */
  numberOfEvictionsFromPortfolio: number | null;
  /**
   * The most common borough for buildings in the portfolio that the BBL belongs
   * to. If the value is unknown, or if there are no associated buildings, this will be null.
   */
  portfolioTopBorough: string | null;
  /**
   * The number of associated buildings in the portfolio's most common borough. If
   * the value is unknown, or if there are no associated buildings, this will be null.
   */
  numberOfBldgsInPortfolioTopBorough: number | null;
  /**
   * The number of rent-stabilized residential units at the BBL in 2007.
   */
  stabilizedUnitCount2007: number;
  /**
   * The number of rent-stabilized residential units at the BBL for the most recent year we have data for.
   */
  stabilizedUnitCount: number;
  /**
   * The year that our data for most-recent stabilized unit count comes from.
   */
  stabilizedUnitCountYear: number;
  /**
   * The maximum number of stabilized units at the BBL on any year between 2007 and 2017.
   */
  stabilizedUnitCountMaximum: number;
  /**
   * The average wait time for repairs, in days, after a landlord has been notified of a violation, if known, for the property.
   */
  averageWaitTimeForRepairsAtBbl: number | null;
  /**
   * The average wait time for repairs, in days, after a landlord has been notified
   * of a violation, if known, for the landlord's entire portfolio.
   */
  averageWaitTimeForRepairsForPortfolio: number | null;
  /**
   * The most common category of HPD complaint, or null if no complaints exist. The
   * full list of categories can be found at: https: // data.cityofnewyork.us/api/views/a2nx-4u46/files/516fa3f1-fff3-4ef4-9ec8-74da856d9cb8?download=true&filename=HPD%20Complaint%20Open%20Data.pdf
   */
  mostCommonCategoryOfHpdComplaint: string | null;
  /**
   * The number of complaints of the most common category of HPD complaint, or null if no complaints exist.
   */
  numberOfComplaintsOfMostCommonCategory: number | null;
  /**
   * The total number of HPD violations since 2010 for the entered BBL.This value
   * will never be null. If no HPD violations are found, it will be 0.
   */
  numberOfTotalHpdViolations: number;
}

export const BlankDDOSuggestionsResult: DDOSuggestionsResult = {
  "fullAddress": "",
  "bbl": "",
  "isNychaBbl": false,
  "isRtcEligible": false,
  "zipcode": "",
  "yearBuilt": null,
  "buildingClass": null,
  "unitCount": 0,
  "hpdComplaintCount": null,
  "hpdOpenViolationCount": 0,
  "hpdOpenClassCViolationCount": null,
  "associatedBuildingCount": null,
  "associatedZipCount": null,
  "portfolioUnitCount": null,
  "numberOfEvictionsFromPortfolio": null,
  "portfolioTopBorough": null,
  "numberOfBldgsInPortfolioTopBorough": null,
  "stabilizedUnitCount2007": 0,
  "stabilizedUnitCount": 0,
  "stabilizedUnitCountYear": 0,
  "stabilizedUnitCountMaximum": 0,
  "averageWaitTimeForRepairsAtBbl": null,
  "averageWaitTimeForRepairsForPortfolio": null,
  "mostCommonCategoryOfHpdComplaint": null,
  "numberOfComplaintsOfMostCommonCategory": null,
  "numberOfTotalHpdViolations": 0
};

export const graphQL = `# This file was auto-generated by querybuilder, please do not edit it.
fragment DDOSuggestionsResult on DDOSuggestionsResult {
  fullAddress,
  bbl,
  isNychaBbl,
  isRtcEligible,
  zipcode,
  yearBuilt,
  buildingClass,
  unitCount,
  hpdComplaintCount,
  hpdOpenViolationCount,
  hpdOpenClassCViolationCount,
  associatedBuildingCount,
  associatedZipCount,
  portfolioUnitCount,
  numberOfEvictionsFromPortfolio,
  portfolioTopBorough,
  numberOfBldgsInPortfolioTopBorough,
  stabilizedUnitCount2007,
  stabilizedUnitCount,
  stabilizedUnitCountYear,
  stabilizedUnitCountMaximum,
  averageWaitTimeForRepairsAtBbl,
  averageWaitTimeForRepairsForPortfolio,
  mostCommonCategoryOfHpdComplaint,
  numberOfComplaintsOfMostCommonCategory,
  numberOfTotalHpdViolations
}`;